const e = { NotDefined: "Undefined", Installed: "Installed", Removed: "Removed" }, l = { Installation: "Install", Removal: "Remove", Check: "Check" };
export {
  l as SealAction,
  e as SealsStatus
};
//# sourceMappingURL=types.js.map
